export class Base {

  public setData(data: any): void {

    for (var key in data) {
      //if (this.hasOwnProperty(key)) {
      this[key] = data[key];
      //}
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/Models/base.ts